import { inject, Ref, ref } from 'vue';
import { ON_BEHALF_OF_CLIENT_INJECT_KEY } from './constants';
import { Client } from 'ah-api-gateways';

export function useOnBehalfOf() {
  return inject<Ref<Client | null>>(ON_BEHALF_OF_CLIENT_INJECT_KEY, ref(null));
}
